// Lesson Templates
import TmpL001 from "./lesson/TmpL001";
import TmpL002 from "./lesson/TmpL002";
import TmpL003 from "./lesson/TmpL003";
import TmpL004 from "./lesson/TmpL004";
import TmpL005 from "./lesson/TmpL005";
import TmpL006 from "./lesson/TmpL006";
import TmpL007 from "./lesson/TmpL007";
import TmpL008 from "./lesson/TmpL008";
import TmpL009 from "./lesson/TmpL009";
import TmpL010 from "./lesson/TmpL010";
import TmpL011 from "./lesson/TmpL011";
import TmpL012 from "./lesson/TmpL012";
import TmpL013 from "./lesson/TmpL013";
import TmpL014 from "./lesson/TmpL014";
import TmpL015 from "./lesson/TmpL015";
// Practical Exercise Templates
import TmpPE001 from "./practicalexercise/TmpPE001";
import TmpPE002 from "./practicalexercise/TmpPE002";
import TmpPE003 from "./practicalexercise/TmpPE003";
import TmpPE004 from "./practicalexercise/TmpPE004";
import TmpPE005 from "./practicalexercise/TmpPE005";
import TmpPE006 from "./practicalexercise/TmpPE006";
import TmpPE007 from "./practicalexercise/TmpPE007";
import TmpPE008 from "./practicalexercise/TmpPE008";
import TmpPE009 from "./practicalexercise/TmpPE009";
import TmpPE010 from "./practicalexercise/TmpPE010";
import TmpPE011 from "./practicalexercise/TmpPE011";
import TmpPE012 from "./practicalexercise/TmpPE012";
import TmpPE013 from "./practicalexercise/TmpPE013";
import TmpPE014 from "./practicalexercise/TmpPE014";
import TmpPE015 from "./practicalexercise/TmpPE015";
import TmpPE016 from "./practicalexercise/TmpPE016";
import TmpPE017 from "./practicalexercise/TmpPE017";
import TmpPE018 from "./practicalexercise/TmpPE018";
import TmpPE019 from "./practicalexercise/TmpPE019";
import TmpPE020 from "./practicalexercise/TmpPE020";
import TmpPE021 from "./practicalexercise/TmpPE021";
import TmpPE022 from "./practicalexercise/TmpPE022";
import TmpPE023 from "./practicalexercise/TmpPE023";
import TmpPE024 from "./practicalexercise/TmpPE024";
import TmpPE025 from "./practicalexercise/TmpPE025";
import TmpPE026 from "./practicalexercise/TmpPE026";
import TmpPE027 from "./practicalexercise/TmpPE027";
import TmpPE028 from "./practicalexercise/TmpPE028";
import TmpPE029 from "./practicalexercise/TmpPE029";
import TmpPE030 from "./practicalexercise/TmpPE030";
// Assessment Templates
import TmpA001 from "./assessment/TmpA001";
import TmpA002 from "./assessment/TmpA002";
import TmpA003 from "./assessment/TmpA003";
import TmpA004 from "./assessment/TmpA004";
// Introduction Templates
import TmpI001 from "./introduction/TmpI001";
import TmpI002 from "./introduction/TmpI002";
import TmpI003 from "./introduction/TmpI003";

const templateHandlers = {
  "TMP-L-001": TmpL001,
  "TMP-L-002": TmpL002,
  "TMP-L-003": TmpL003,
  "TMP-L-004": TmpL004,
  "TMP-L-005": TmpL005,
  "TMP-L-006": TmpL006,
  "TMP-L-007": TmpL007,
  "TMP-L-008": TmpL008,
  "TMP-L-009": TmpL009,
  "TMP-L-010": TmpL010,
  "TMP-L-011": TmpL011,
  "TMP-L-012": TmpL012,
  "TMP-L-013": TmpL013,
  "TMP-L-014": TmpL014,
  "TMP-L-015": TmpL015,
  "TMP-PE-001": TmpPE001,
  "TMP-PE-002": TmpPE002,
  "TMP-PE-003": TmpPE003,
  "TMP-PE-004": TmpPE004,
  "TMP-PE-005": TmpPE005,
  "TMP-PE-006": TmpPE006,
  "TMP-PE-007": TmpPE007,
  "TMP-PE-008": TmpPE008,
  "TMP-PE-009": TmpPE009,
  "TMP-PE-010": TmpPE010,
  "TMP-PE-011": TmpPE011,
  "TMP-PE-012": TmpPE012,
  "TMP-PE-013": TmpPE013,
  "TMP-PE-014": TmpPE014,
  "TMP-PE-015": TmpPE015,
  "TMP-PE-016": TmpPE016,
  "TMP-PE-017": TmpPE017,
  "TMP-PE-018": TmpPE018,
  "TMP-PE-019": TmpPE019,
  "TMP-PE-020": TmpPE020,
  "TMP-PE-021": TmpPE021,
  "TMP-PE-022": TmpPE022,
  "TMP-PE-023": TmpPE023,
  "TMP-PE-024": TmpPE024,
  "TMP-PE-025": TmpPE025,
  "TMP-PE-026": TmpPE026,
  "TMP-PE-027": TmpPE027,
  "TMP-PE-028": TmpPE028,
  "TMP-PE-029": TmpPE029,
  "TMP-PE-030": TmpPE030,
  "TMP-A-001": TmpA001,
  "TMP-A-002": TmpA002,
  "TMP-A-003": TmpA003,
  "TMP-A-004": TmpA004,
  "TMP-I-001": TmpI001,
  "TMP-I-002": TmpI002,
  "TMP-I-003": TmpI003,
};

export default templateHandlers;